import React from 'react';
import HomePage from './pages/HomePage/HomePage';
import ServicesPage from './pages/ServicesPage/ServicesPage';
import ContactPage from './pages/ContactPage/ContactPage';
import MissionPage from './pages/MissionPage/MissionPage';
import StorePage from './pages/StorePage/StorePage';
import AppointmentPage from './pages/AppointmentPage/AppointmentPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/mission" element={<MissionPage />} />
        <Route path="/store" element={<StorePage />} />
        <Route path="/appointment" element={<AppointmentPage />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default AppRouter;